<div class="container" *ngIf="product">
  <app-header
    [imageUrl]="product.imageUrl"
  ></app-header>

  <div class="content">
    <app-product-info
      [title]="product.name"
      [description]="product.description"
      [price]="product.price/100"
      [tags]="product.tags"
    ></app-product-info>

    <app-restaurant-info
      [id]="restaurant.zigBarId"
      [imageUrl]="restaurant.imageLogoUrl"
      [name]="restaurant.name"
      [description]="restaurant.description"
    ></app-restaurant-info>

    <div class="content-suggestions">
      <h3>{{ 'PRODUCT.FOLLOW_UP_SUGGESTION' | translate }}</h3>
      <div class="cards-wrapper">
        @for (item of listSuggestions; track item) {
          <app-product-card
            layout="vertical"
            [id]="item.id"
            [imageUrl]="item.imageUrl"
            [title]="item.name"
            [price]="item.price/100"
            [productData]="item"
          ></app-product-card>
        }
      </div>
    </div>
  </div>
</div>

